import React, {useRef} from "react";
import styled, {useTheme} from "styled-components";
import Image from "@/components/common/Image";
import {getAspectRatioFromImage, getCssSizeValue, getHtmlFromRedactorField, isStringEmpty} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import ExternalLink from "@/components/common/Links/ExternalLink";
import {IMAGE_FALLBACK} from "@/constants";
import Text from "@/components/common/Text";
import useColor from "@/hooks/useColor";

const Wrapper = styled(ExternalLink)`
	display: flex;
	max-width: 100%;
	flex-direction: column;
	justify-content: space-between;
	background-color: ${({ $background }) => $background};
	border: ${({ $borderColor }) => $borderColor ? `1px solid ${$borderColor}` : `none`} !important ;
	row-gap: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
    aspect-ratio: 293/240;
    padding: 
			${getCssSizeValue(24, BREAKPOINTS.MOBILE)} 
			${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
   

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        aspect-ratio: 427/280;
        padding:
                ${getCssSizeValue(24, BREAKPOINTS.TABLET)}
                ${getCssSizeValue(24, BREAKPOINTS.TABLET)}
                ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
    }

	@media (min-width: ${({theme}) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
        row-gap: ${getCssSizeValue(33, BREAKPOINTS.DESKTOP)};
		padding: ${getCssSizeValue(24)} ${getCssSizeValue(24)} ${getCssSizeValue(40)};
        aspect-ratio: 427/285;
		height: 100%;
    }
`;

const LogoWrapper = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: center;
	height: 100%
`

const Logo = styled(Image)`
    aspect-ratio: ${({$aspectRatio}) => $aspectRatio || 16 / 9};
	height: 75%;
    width: auto;
`

export const BACKGROUND_VARIANTS = {
	GREY: 'grey',
	DARK: 'dark',
	BORDER: 'border'
}

export function getColorsBasedOnVariant(variant = BACKGROUND_VARIANTS.GREY) {
	let result = {}

	switch (variant) {
		case BACKGROUND_VARIANTS.GREY:
			result = {
				text: 'richBlue',
				background: 'platinum',
				border: null
			}
			break;
		case BACKGROUND_VARIANTS.DARK:
			result = {
				text: 'platinum',
				background: 'richBlack',
				border: null
			}
			break;
		case BACKGROUND_VARIANTS.BORDER:
			result = {
				text: 'richBlue',
				background: 'white',
				border: 'platinum'
			}
			break;
		default:
			result = {
				text: 'richBlue',
				background: 'platinum',
				border: null
			}
	}

	return result;
}


export default function Item({ data, className='' }) {
	const LogoRef = useRef()
	const name = data?.name || ''
	const logo = data?.logo || IMAGE_FALLBACK
	const aspectRatio = getAspectRatioFromImage(data?.logo || {})
	const sliderBackgroundVariant = data?.sliderBackgroundVariant || BACKGROUND_VARIANTS.GREY;
	const cardColors = getColorsBasedOnVariant(sliderBackgroundVariant)
	const bgColor = useColor(cardColors.background)
	const borderColor = useColor(cardColors.border)
	const websiteURL = data?.websiteUrl || ''
	const theme = useTheme()

	return (
		<Wrapper
			className={`${className}`}
			href={websiteURL}
			$background={bgColor}
			$borderColor={borderColor}
			newCard="yes"
			as={isStringEmpty(websiteURL) ? 'div' : ExternalLink}
		>
			<Text as="div" color={cardColors.text} className='typo-strawford typo-strawford-14' dangerouslySetInnerHTML={getHtmlFromRedactorField(name)}/>
			<LogoWrapper>
				<Logo
					ref={LogoRef}
					src={logo.url}
					alt={logo.alt || 'SinglePartner Logo'}
					$aspectRatio={aspectRatio}
					className="partner-logo"
				/>
			</LogoWrapper>
		</Wrapper>
	);
}
